import { saveAll } from "util/archive";
import {
  DEPRECATED_RETRIEVAL_PAGE_DISPLAY_NAME,
  RETRIEVAL_PAGE_DISPLAY_NAME,
} from "constants/document";

import type { SaveAllBundle as DocumentBundle } from "./bundle_fragment.graphql";

function retrievalPageMetadata(url: string, isProof: boolean) {
  return {
    name: isProof ? RETRIEVAL_PAGE_DISPLAY_NAME : DEPRECATED_RETRIEVAL_PAGE_DISPLAY_NAME,
    url,
  };
}

function archiveMetadata(
  { documents, retrieval_page_file: retrievalPage }: DocumentBundle,
  isProof: boolean,
) {
  const docInfo = documents.edges.map(({ node: { final_asset } }) => ({
    url: final_asset!.url!,
    name: final_asset!.downloadName!,
  }));
  const retrievalPageInfo = !retrievalPage
    ? []
    : [retrievalPageMetadata(retrievalPage.url!, isProof)];
  return retrievalPageInfo.concat(docInfo);
}

export function asArchive(documentBundle: DocumentBundle, isProof: boolean) {
  return saveAll({
    archiveName: documentBundle.name || "Archive",
    files: archiveMetadata(documentBundle, isProof),
  });
}

export function downloadAllOriginalAssets({ name, documents }: DocumentBundle) {
  return saveAll({
    archiveName: `Original - ${name}`,
    files: documents.edges.map(({ node }) => ({
      url: node.s3UploadedAsset!.url!,
      name: node.name!,
    })),
  });
}
